export function fireOnWindowLoadEventOnce( callbackFn = () => {}) {
	window.addEventListener( 'load',
		() => setTimeout(callbackFn, 200),
		{ once: true }
	)
}
